var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#2674FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 33C23.4477 33 23 33.4477 23 34C23 34.5523 23.4477 35 24 35L24 33ZM44.7071 34.7071C45.0976 34.3166 45.0976 33.6834 44.7071 33.2929L38.3431 26.9289C37.9526 26.5384 37.3195 26.5384 36.9289 26.9289C36.5384 27.3195 36.5384 27.9526 36.9289 28.3431L42.5858 34L36.9289 39.6569C36.5384 40.0474 36.5384 40.6805 36.9289 41.0711C37.3195 41.4616 37.9526 41.4616 38.3431 41.0711L44.7071 34.7071ZM24 35L44 35L44 33L24 33L24 35Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.18d8fcdecb9887a58311fec851ea05ff.svg";
export { ForwardRef as ReactComponent };